import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = filters => {
    return {
        filtro: filters.search,
        ordem: filters.orderBy,
        desc: filters.desc
    };
};

export default Object.assign(
    {
        apiUrl: "/ipfirewall",

        async list({ pagination, filters }) {
            const url = this.url(
                `/${pagination.page}/${pagination.amountPerPage}`
            );
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query
            });
        },

        async count({ filters }) {
            const url = this.url(`/paginacao`);
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query
            });
        },

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(this.url(), data)
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async remove(id) {
            const url = this.url(`/${id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.delete(url).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        }
    },
    base
);
